"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typographyType = exports.fontStyles = exports.fontWeights = exports.fontSizesAsNumbers = exports.fontSizes = exports.fontFamilies = void 0;
exports.fontFamilies = [
    'Archivo Narrow',
    'Arial',
    'BioRhyme',
    'Caveat',
    'Comic Neue',
    'Courier Prime',
    'Dosis',
    'DM Mono',
    'DM Sans',
    'Eczar',
    'Georgia',
    'Hanken Grotesk',
    'IBM Plex Mono',
    'IBM Plex Sans',
    'IM Fell English',
    'Impact',
    'Inconsolata',
    'Inknut Antiqua',
    'Inter',
    'Jost',
    'Kreon',
    'Lato',
    'Lora',
    'Lucida Grande',
    'Merriweather',
    'Montserrat',
    'Odin Rounded',
    'Oswald',
    'OpenDyslexic',
    'OpenDyslexicMono',
    'Open Sans',
    'Palatino',
    'Pangolin',
    'Playfair Display',
    'Plus Jakarta Sans',
    'Pompiere',
    'Poppins',
    'Princess Sofia',
    'Proza Libre',
    'Questrial',
    'Raleway',
    'Roboto',
    'Roboto Slab',
    'Shadows Into Light Two',
    'Space Grotesk',
    'Space Mono',
    'Source Sans 3',
    'Source Serif 4',
    'Syne Mono',
    'Times New Roman',
    'Trebuchet MS',
    'Varela Round',
    'Verdana',
    'Work Sans',
];
exports.fontSizes = [
    '10px',
    '13px',
    '15px',
    '16px',
    '18px',
    '24px',
    '28px',
    '32px',
    '36px',
    '48px',
    '64px',
    '96px',
    '128px',
];
exports.fontSizesAsNumbers = exports.fontSizes.map((size) => parseFloat(size.replace('px', '')));
exports.fontWeights = ['regular', 'bold'];
exports.fontStyles = ['italic'];
exports.typographyType = ['title', 'subtitle', 'body', 'small'];
//# sourceMappingURL=font-settings.js.map